import React, { createContext, useContext, useEffect, useState } from "react";

const ctx = createContext(false);
const { Provider } = ctx;

export const useFeatureFlag = () => {
  const enabled = useContext(ctx);
  return enabled;
};

export const FeatureFlagProvider = ({ shouldEnable, children }) => {
  const [enabled, setEnabled] = useState(shouldEnable);

  useEffect(() => {
    if (typeof shouldEnable === "function") {
      setEnabled(shouldEnable());
    }
  }, []);

  return <Provider value={enabled}>{children}</Provider>;
};

export const FeatureFlag = ({ as, active = false, children }) => {
  // There are times where you would need a different kind of element to be wrapped
  // around not just a block based one
  const TagName = as || "div";
  const enabled = useContext(ctx);

  // If the feature flag is not turned on, we should not render the contents at all
  if (!active && !enabled) {
    return null;
  }

  return (
    <TagName
      style={{
        outline: `1px solid magenta`,
      }}
    >
      {children}
    </TagName>
  );
};
